export const FETCH_NEXT_BOOKING_REQUEST = 'FETCH_NEXT_BOOKING_REQUEST';
export const FETCH_NEXT_BOOKING_SUCCESS = 'FETCH_NEXT_BOOKING_SUCCESS';
export const FETCH_NEXT_BOOKING_FAILURE = 'FETCH_NEXT_BOOKING_FAILURE';

export const fetchNextBookingRequest = () => ({
  type: FETCH_NEXT_BOOKING_REQUEST
});

export const fetchNextBookingSuccess = response => ({
  type: FETCH_NEXT_BOOKING_SUCCESS,
  payload: response
});

export const fetchNextBookingFailure = err => ({
  type: FETCH_NEXT_BOOKING_FAILURE,
  payload: err,
  error: true
});



// WEBPACK FOOTER //
// ./src/store/bookings/actions.js